module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "30px 0"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Mere Shepherd Boy – Book 1")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-in-bethlehem"
    }
  }, [_vm._v("Chapter 1: In Bethlehem")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-blind-mans-buff"
    }
  }, [_vm._v("Chapter 2: Blind Man’s Buff")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-a-princess-and-a-harp"
    }
  }, [_vm._v("Chapter 3: A Princess and a Harp")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-the-second-encounter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Second Encounter")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-zizi-and-didi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Zizi and Didi")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-the-day-of-the-shepherd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Day of the Shepherd")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-a-time-to-learn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: A Time to Learn")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-an-inspiration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: An Inspiration")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-into-the-lions-den",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Into the Lion’s Den")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-on-the-shores-of-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: On the Shores of Time")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-two-meetings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Two Meetings")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-reflections",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Reflections")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-ahinoam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Ahinoam")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-to-the-court-of-king-saul",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: To the Court of King Saul")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-within-the-walls",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Within the Walls")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-an-impetuous-youth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: An Impetuous Youth")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-deep-calling-to-deep",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Deep Calling to Deep")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-puzzles-from-the-past",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18 Puzzles from the Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-an-unexpected-mission",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: An Unexpected Mission")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-the-chorus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: The Chorus")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0